import { Base } from '@studiometa/js-toolkit';
import ProductInfo from './ProductInfo/index.js';
import ZoomedGallery from './ZoomedGallery/index.js';
import Gallery from './Gallery.js';
import ProductStickyBar from '../ProductStickyBar.js';

/**
 * Popin Newsletter class.
 * @todo refactor and explode structure & component
 */
export default class Product extends Base {
  static config = {
    name: 'Product',
    components: {
      ProductInfo,
      Gallery,
      ZoomedGallery,
      ProductStickyBar,
    },
    refs: ['addToCart'],
  };

  /**
   * Synch all quantity inputs
   * @param {*} index Index of element clicked
   * @param {*} referrer Referrer element
   * @returns {void}
   */
  updateAllQuantities(index, referrer) {
    if (referrer === 'ProductStickyBar') {
      this.$children.ProductInfo[0].$children.QuantitySelect[0].setItemActive(index);
      return;
    }

    this.$children.ProductStickyBar[0].$children.QuantitySelect[0].setItemActive(index);
  }
}
